export default [
  {
    gitlab: 'https://gitlab.com/Taucher2003',
    name: 'Niklas van Schrick',
    merged_mrs: 92,
    category: 'SuperStar',
  },
  {
    gitlab: 'https://gitlab.com/bbodenmiller',
    name: 'Ben Bodenmiller',
    merged_mrs: 82,
    category: 'SuperStar',
  },
  {
    gitlab: 'https://gitlab.com/daelmo',
    name: 'David Elizondo',
    merged_mrs: 79,
    category: 'SuperStar',
  },
  {
    gitlab: 'https://gitlab.com/PatrickRice',
    name: 'Patrick Rice',
    merged_mrs: 69,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/zillemarco',
    name: 'Marco Zille',
    merged_mrs: 68,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/JonstonChan',
    name: 'Jonston Chan',
    merged_mrs: 60,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/starvader13',
    name: 'Ashutosh Gupta',
    merged_mrs: 55,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/TrueKalix',
    name: 'Andreas Deicha',
    merged_mrs: 52,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/Suneha1',
    name: 'Suneha Patel',
    merged_mrs: 48,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/ShaneMaglangit',
    name: 'Shane Maglangit',
    merged_mrs: 46,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/abitrolly',
    name: 'Anatoli Babenia',
    merged_mrs: 45,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/syedzubeen',
    name: 'Zubeen',
    merged_mrs: 45,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/tedtran2019',
    name: 'Ted Tran',
    merged_mrs: 43,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/gerardo-navarro',
    name: 'Gerardo Navarro',
    merged_mrs: 40,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/missy-davies',
    name: 'Missy Davies',
    merged_mrs: 38,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/luzhiyuan.deer',
    name: 'Zhiyuan Lu',
    merged_mrs: 35,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/abhijeet007rocks8',
    name: 'Abhijeet Chatterjee',
    merged_mrs: 33,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/nakiyama-ext',
    name: 'Noriko Akiyama',
    merged_mrs: 33,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/JeremyWuuuuu',
    name: 'Wu Jeremy',
    merged_mrs: 30,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/qk44077907',
    name: 'Kun Qian',
    merged_mrs: 29,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/catinbag',
    name: 'Dmitry Silin',
    merged_mrs: 29,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/sathieu',
    name: 'Mathieu Parent',
    merged_mrs: 28,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/ochorocho',
    name: 'Jochen',
    merged_mrs: 27,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/zhanglinjie',
    name: 'Linjie Zhang',
    merged_mrs: 24,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/tspearconquest',
    name: 'Thomas Spear',
    merged_mrs: 23,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/omarybelgamh',
    name: 'Omar Belgamh',
    merged_mrs: 23,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/sayeedahmad',
    name: 'Sayeed Ahmad',
    merged_mrs: 23,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/arnvgl',
    name: 'Arnav Goel',
    merged_mrs: 22,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/zhzhang93',
    name: 'Zehua Zhang',
    merged_mrs: 21,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/Mughees_',
    name: 'Mughees Pervaiz',
    merged_mrs: 21,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/alexandralicht0',
    name: 'Alexandra Licht',
    merged_mrs: 20,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/icbd',
    name: 'Baodong',
    merged_mrs: 20,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/bmillemathias',
    name: 'Baptiste Mille-Mathias',
    merged_mrs: 20,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/MindTooth',
    name: 'Birger J. Nordølum',
    merged_mrs: 19,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/takamine-ext',
    name: 'Tieme Akamine',
    merged_mrs: 19,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/bymayanksingh',
    name: 'Mayank Singh',
    merged_mrs: 18,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/lyb124553153',
    name: 'Yongbo li',
    merged_mrs: 18,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/winniehell',
    name: 'Winnie',
    merged_mrs: 17,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/mbradburn-ext',
    name: 'Matthew Bradburn',
    merged_mrs: 16,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/zarthus',
    name: 'Jos Ahrens',
    merged_mrs: 16,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/taoheng',
    name: 'Tao Heng',
    merged_mrs: 16,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/zzaakiirr',
    name: 'Zakir Dzhamaliddinov',
    merged_mrs: 15,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/oelmekki',
    name: 'kik',
    merged_mrs: 14,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/blanet',
    name: 'Xing Xin',
    merged_mrs: 14,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/Ashvith',
    name: 'Ashvith',
    merged_mrs: 14,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/glauciellesa',
    name: 'Glaucielle Sa',
    merged_mrs: 13,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/edith007',
    name: 'Siddharth Asthana',
    merged_mrs: 13,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/X_Sheep',
    name: 'Lennard Sprong',
    merged_mrs: 12,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/oli_brr',
    name: 'Oliver',
    merged_mrs: 12,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/ar-mali',
    name: 'Muhammed Ali',
    merged_mrs: 11,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/xfyuan',
    name: 'xfyuan',
    merged_mrs: 11,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/joe-snyder',
    name: 'Joe Snyder',
    merged_mrs: 11,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/claromes',
    name: 'claromes',
    merged_mrs: 11,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/rgarcia65201',
    name: 'Ryan Garcia',
    merged_mrs: 11,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/osbre',
    name: 'Ostap Brehin',
    merged_mrs: 11,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/hristiyan.ivanov',
    name: 'Hristiyan Ivanov',
    merged_mrs: 10,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/renehernandez',
    name: 'René Hernández Remedios',
    merged_mrs: 10,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/afzal442',
    name: 'Afzal Ansari',
    merged_mrs: 10,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/KyleFromKitware',
    name: 'Kyle Edwards',
    merged_mrs: 10,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/markus.ferrell',
    name: 'Markus Ferrell',
    merged_mrs: 10,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/imrishabh18',
    name: 'Rishabh Gupta',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/CBID2',
    name: 'Christine Belzie',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/gtsiolis',
    name: 'George Tsiolis',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/dannyelcf',
    name: 'Dannyel Cardoso da Fonseca',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/tianlu1677',
    name: 'TianLu',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/mareo',
    name: 'Marin Hannache',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/songhuangcn',
    name: 'Song Huang',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/josephjose',
    name: 'Joseph Jose',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/lzampier',
    name: 'Lucas Zampieri',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/ericcornelissen',
    name: 'Eric Cornelissen',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/NIKU-SINGH',
    name: 'Niku Singh',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/fenyuluoshang',
    name: 'fenyu',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/KiranSatyaRaj',
    name: 'KiranSatyaRaj',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/msolodovnik-ext',
    name: 'Mariia Solodovnik',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/wwwjon',
    name: 'Jonas Wälter',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/lankaD-ext',
    name: 'Lanka De Alwis',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/TamsilAmani',
    name: 'Tamsil Sajid Amani',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/mness',
    name: 'Mark Nessen',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/Mat.G',
    name: 'Mat Gautron',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/FromTheStackAndBack',
    name: 'FromTheStackAndBack',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/ali_o_kan',
    name: 'Laurent Deketelaere',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/vaibhavx42',
    name: 'Vaibhav Bhardwaj',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/Roshani9731',
    name: 'Roshani  Navdiya',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/jeanphi-baconnais',
    name: 'Jean-Philippe Baconnais',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/chathumina96-ext',
    name: 'Chathumina Vimukthi',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/rndmh3ro',
    name: 'Sebastian Gumprich',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/davidwatts111',
    name: 'David Watts',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/antonis.stamatiou',
    name: 'Antonis Stamatiou',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/harshitprasad',
    name: 'Harshit Prasad',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/behrmann',
    name: 'Jörg Behrmann',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/lxwan',
    name: 'Lixin Wan',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/nejc',
    name: 'Nejc Habjan',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/maltejk',
    name: 'Malte Jan Kaffenberger',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/przbadu',
    name: 'Pushpa Raj Badu',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/kranurag7',
    name: 'kranurag7',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/biesiad',
    name: 'Michal Biesiada',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/AnWeber',
    name: 'Andreas Weber',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/tmeijn',
    name: 'Tyrone Meijn',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/waldyrious',
    name: 'Waldir Pimenta',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/mitar',
    name: 'Mitar',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/egor-kh',
    name: 'Egor',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/akis.maziotis',
    name: 'Akis Maziotis',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/LeanneMarie',
    name: 'Leanne Tickett',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/arukiidou',
    name: 'arukiidou',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/homersimpsons',
    name: 'homer',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/danielhass',
    name: 'Daniel Haß',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/deep-swaraj',
    name: 'Swaraj Deep',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/yodamad',
    name: 'yodamad',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/candrews',
    name: 'Craig Andrews',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/vincent_stchu',
    name: 'vincent stchu',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/ChevronTango',
    name: 'ChevronTango',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/kingcrunch',
    name: 'Sebastian Krebs',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/okin',
    name: 'Niko',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/fxli',
    name: 'fx Li',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/nfason',
    name: 'Nicholas Fason',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/soma2000',
    name: 'SOMASREE  MAJUMDER',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/tmfrstn',
    name: 'Timo Feuerstein',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/sato11',
    name: 'Junichi Sato',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/der.bruemmer',
    name: 'DEV user',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/aleal-ext',
    name: 'Alvise Leal',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
];
